module.exports = global["pdfMake"] = require("-!.\\pdfMake.js");